<template>
	<div>
		<navpage
			ref="navPage"
			:middle="true"
			pagename="incoming"
			:displayDates="true"
			:displayFilters="false"
			:updateParameters="false"
			:displayAllButton="false"
			@datepickercreated="setDates()"
			@changedate="changeDate($event)"
		>
		</navpage>
		<div id="content-page">
			<newtrendfilter
				ref="newtrendfilter"
				v-bind="{ displayincoming: true, selectedDate: date }"
				@trendfilters="trendFilters($event)"
			>
			</newtrendfilter>
			<semanticfilter ref="semanticfilter" v-bind="{ displayincoming: true }" @semanticfilters="semanticFilters($event)">
			</semanticfilter>
			<div class="row dynvibeRow">
				<div class="col-lg-12 dynvibeBox">
					<div class="col-lg-12 dynvibeTitleBox">
						<h2>New associations</h2>
					</div>
					<dynvibedynamictable
						ref="dynvibeDynamicTable"
						@createmastertag="createMastertag($event)"
						v-bind="$data"
						level="keywords"
					>
					</dynvibedynamictable>
					<dynvibedynamictable
						ref="dynvibeDynamicTable"
						@createmastertag="createMastertag($event)"
						v-bind="$data"
						level="hashtags"
					>
					</dynvibedynamictable>
					<dynvibedynamictable
						ref="dynvibeDynamicTable"
						@createmastertag="createMastertag($event)"
						v-bind="$data"
						level="mentions"
					>
					</dynvibedynamictable>
				</div>
			</div>
			<createmastertag ref="createmastertag"></createmastertag>
		</div>
	</div>
</template>
<script>
import navpage from "@/components/globalVue/Nav.vue";
import newtrendfilter from "@/components/globalVue/NewTrendFilter.vue";
import semanticfilter from "@/components/globalVue/SemanticFilter.vue";
import dynvibedynamictable from "@/components/vueCharts/DynvibeDynamicTable.vue";
import createmastertag from "@/components/incoming/CreateMastertag.vue";

export default {
	name: "incoming",
	data() {
		return {
			trendfilters: {},
			semanticfilters: [],
			date: {},
		};
	},
	components: {
		navpage: navpage,
		newtrendfilter: newtrendfilter,
		semanticfilter: semanticfilter,
		dynvibedynamictable: dynvibedynamictable,
		createmastertag: createmastertag,
	},
	methods: {
		trendFilters(val) {
			this.trendfilters = val;
			this.$refs.createmastertag.fillData(val, "trendfilters");
		},
		semanticFilters(val) {
			this.semanticfilters = val;
			this.$refs.createmastertag.fillData(val, "semanticfilters");
		},
		createMastertag(val) {
			this.$refs.createmastertag.fillData(val);
		},
		setDates() {
			this.$refs.navPage.setDates(null, null);
		},
		changeDate($event) {
			this.date.gte = $event.gte;
			this.date.lte = $event.lte;
		},
	},
};
</script>

<style></style>
